import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { logError, logEvent } from '@/modules/analytics'
import { useSystemStore } from '@/stores/system'
import App from './App.vue'
import router from '@/router'
import i18n from '@/modules/i18n'
import type { Composer } from 'vue-i18n'

import '@/main.css'

window.addEventListener('appinstalled', () => {
  logEvent('install_pwa')
})

const pinia = createPinia()

const app = createApp(App).use(pinia).use(router).use(i18n)

pinia.use(({ store }) => {
  store.$i18n = i18n.global as Composer
})

app.config.errorHandler = (error: any, component, info) => {
  if (!import.meta.env.PROD) {
    console.error(error)
  }
  logError('Unhandled error', error, {
    code: error.code ?? 'unknown',
    path: router.currentRoute.value.path,
    component: component?.$options.name ?? 'Unknown component'
  })
  return router.replace({ name: '404' })
}

const systemStore = useSystemStore(pinia)

systemStore.initialisePlatform()

const sizeListener = () => {
  systemStore.isSmallScreen = window.innerWidth < 756
}
window.addEventListener('load', sizeListener)
window.addEventListener('resize', sizeListener)

app.mount('#app')
